import { Map } from 'immutable'
import { User } from 'data/records'
import { getCurrentUser } from 'lib/utils'
import { member, resource, findSelector, withAllResults } from 'data/helpers/apiv3'

const [api, actions] = resource(User, [
  member.get('liveLog', ['routeId', 'lastUpdatedAt', 'privacyCode']),
  member.get('friends'),
  member.get('friendRequests'),
  member.get('privateUserShow'),
  member.post('confirmFriendRequest'),
  member.post('declineFriendRequest'),
  member.post('befriend'),
  member.post('unfriend')
])
actions.allFriends = withAllResults(actions.friends)
actions.allFriendRequests = withAllResults(actions.friendRequests)

const selectors = {
  ...findSelector(User)
}

// we Map().set() here because we need the key to remain an integer.
// Map({1: 'foo'}) includes an intermediate representation that coerces the int
// to a string
const currentUser = getCurrentUser()
const initialState = {
  id: currentUser.id ? Map().set(currentUser.id, User(currentUser)) : Map() // overwrite id Map to include currentUser
}

const reducers = {}

export {
  api as userApi,
  actions as userActions,
  selectors as userSelectors,
  reducers as userReducers,
  initialState as userInitialState
}
